import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal, RevealStagger, revealItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { Newspaper, ArrowUpRight, Calendar } from "lucide-react";
import { BLOG_POSTS } from "../data/site";
import { useLang } from "../context/LanguageContext";

export default function Blog() {
  const { t } = useLang();
  return (
    <div className="App">
      <Navbar />

      <section className="bg-brand-gray text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 text-brand-orange font-heading font-bold uppercase tracking-[0.2em] text-sm">
            <Newspaper size={16} /> {t.nav.blog}
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-3">Stories from the Road</h1>
          <p className="text-white/70 mt-3 max-w-2xl">Tips, guides and adventures for riding San Juan del Sur and beyond.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <RevealStagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.map((post, i) => (
              <motion.a
                key={i}
                variants={revealItem}
                href={post.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`blog-post-${i}`}
                className="group flex flex-col bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all"
              >
                <div className="h-52 overflow-hidden bg-slate-100">
                  <img src={post.image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-brand-sky">
                    <Calendar size={13} /> {post.date}
                  </span>
                  <h2 className="font-heading font-extrabold text-lg text-brand-gray mt-2 leading-snug group-hover:text-brand-blue transition-colors">{post.title}</h2>
                  <p className="text-slate-500 text-sm mt-3 leading-relaxed flex-1">{post.excerpt}</p>
                  <span className="inline-flex items-center gap-1 mt-5 font-heading font-bold text-brand-orange group-hover:gap-2 transition-all">
                    Read article <ArrowUpRight size={16} />
                  </span>
                </div>
              </motion.a>
            ))}
          </RevealStagger>
        </div>
      </section>

      <Footer />
    </div>
  );
}
